import { Routes } from '@angular/router';
import { StudentLayoutComponent } from 'app/shared/components/layouts/student-layout/student-layout.component';
import { AuthLayoutComponent } from 'app/shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './services/auth/student-auth.guard';

export const rootRouterConfig: Routes = [
    {
        path: '',
        redirectTo: 'student',
        pathMatch: 'full',
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'sessions',
                loadChildren: () =>
                    import('./views/sessions/sessions.routing').then(
                        (m) => m.SessionsRoutes
                    ),
                data: { title: 'Session' },
            },
        ],
    },
    {
      path: 'verify',
      loadChildren: () =>
        import('./views/certificate-verify/certificate-verify.routing').then(
          (m) => m.CertificateVerifyRoutes
        ),
    },
    {
        path: '',
        component: StudentLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'student',
                loadChildren: () =>
                    import('./views/student/student.routing').then(
                        (m) => m.StudentRoutes
                    ),
                data: { title: 'Student', breadcrumb: 'STUDENT' },
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'student',
    },
];
